// ============================================================
// Coordinate utilities
// ============================================================

import { type Position, BOARD_SIZE, FILES } from '@core/types';

/** Convert screen coordinates to board position given layout params */
export function screenToBoard(
  screenX: number,
  screenY: number,
  origins: Array<{ x: number; y: number }>,
  cellSize: number,
): Position | null {
  for (let w = 0; w < origins.length; w++) {
    const ox = origins[w].x;
    const oy = origins[w].y;
    const localX = screenX - ox;
    const localY = screenY - oy;

    if (localX >= 0 && localX < BOARD_SIZE * cellSize &&
        localY >= 0 && localY < BOARD_SIZE * cellSize) {
      const x = Math.floor(localX / cellSize);
      const y = BOARD_SIZE - 1 - Math.floor(localY / cellSize); // flip Y for display
      return { x, y, w };
    }
  }
  return null;
}

/** Convert board position to algebraic string */
export function posToAlgebraic(p: Position): string {
  return `${FILES[p.x]}${p.y + 1}`;
}

/** Manhattan distance between two positions (spatial only) */
export function manhattanDist(a: Position, b: Position): number {
  return Math.abs(a.x - b.x) + Math.abs(a.y - b.y) + Math.abs(a.w - b.w);
}
